import { render, staticRenderFns } from "./ReceiptDetail.vue?vue&type=template&id=509d60f2&scoped=true"
import script from "./ReceiptDetail.vue?vue&type=script&lang=ts"
export * from "./ReceiptDetail.vue?vue&type=script&lang=ts"
import style0 from "./ReceiptDetail.vue?vue&type=style&index=0&id=509d60f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509d60f2",
  null
  
)

export default component.exports